import axios from "axios";

export default {
    state: {
        purchaseRequest: {},
        purchaseRequestDeclarations: [],
        redirectUrl: null
    },
    mutations: {
        setPurchaseRequest(state, purchaseRequest) {
            state.purchaseRequest = purchaseRequest;
        },
        setPurchaseRequestDeclarations(state, purchaseRequestDeclarations) {
            state.purchaseRequestDeclarations = purchaseRequestDeclarations;
        },
        setRedirectUrl(state, url) {
            state.redirectUrl = url;
        }
    },
    getters:{
        getPurchaseRequest(state) {
            return state.purchaseRequest;
        },
        getPurchaseRequestDeclarations(state) {
            return state.purchaseRequestDeclarations;
        },
        getRedirectUrl(state) {
            return state.redirectUrl;
        }
    },
    actions: {
        async fetchPurchaseRequest({ commit }, id) {
            try {
                const response = await axios.get(`/user-dashboard/purchase-requests/show/${id}`);
                commit('setPurchaseRequest', response.data?.data);
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        async fetchPurchaseRequestDeclarations({ commit }) {
            try {
                const response = await axios.get('/user-dashboard/purchase-requests/create?request=ajax');
                commit('setPurchaseRequestDeclarations', response.data);
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        async createOrderProduct({ commit }, data) {
            try {
                await axios.post('/user-dashboard/purchase-requests/store-declaration' ,data);
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        async deletePurchaseRequestDeclaration({ commit }, id) {
            try {
                await axios.delete(`/user-dashboard/purchase-requests/declaration/${id}`);
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        async createPurchaseRequest({ commit }, data) {
            try {
                const response = await axios.post('/user-dashboard/purchase-requests/store', data);
                commit('setRedirectUrl', response.data.redirect_url);
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        async deletePurchaseRequest({ commit }, id) {
            try {
                await axios.delete(`/user-dashboard/purchase-requests/${id}`);
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        async rollbackPurchaseRequest({ commit }, id) {
            try {
                await axios.get(`/user-dashboard/purchase-requests/rollback/${id}`);
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        async payPurchaseRequest({ commit }, id) {
            try {
                await axios.get(`/user-dashboard/purchase-requests/pay/${id}`);
            } catch (e) {
                console.log(e);
                throw e;
            }
        }
    }
};
